import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { AppConfigurationService } from 'src/app/core/services/app-configuration.service';
import { TokenService } from 'src/app/core/services/token.service';
import { Credentials } from '../models/credentials.model';

@Injectable({
    providedIn: 'root',
})
export class LoginService {

    private apiURL: string;
    private httpWithoutInterceptor: HttpClient;

    constructor(
        private http: HttpClient,
        private httpBackend: HttpBackend,
        private router: Router,
        private appConfigurationService: AppConfigurationService,
        private tokenService: TokenService) {

            this.apiURL = this.appConfigurationService.baseApi + '/login';
            this.httpWithoutInterceptor = new HttpClient(httpBackend);

    }

    public login(credentials: Credentials) {

        const url = this.apiURL + '/tutor';
        return this.httpWithoutInterceptor.post(url, credentials, { headers: new HttpHeaders(), responseType: 'text'}).pipe(
            map((response: string) => {
                this.tokenService.setToken(response);
                return response;
            }),
            catchError((httpError: HttpErrorResponse) => {
                var error = this.handleHttpError(httpError);
                return throwError(error);
            })
        );

    }

    public resetPassword(email: string) : any {

        const url = this.apiURL + '/tutor/forgot?email=' + email;
        return this.httpWithoutInterceptor.get(url, { headers: new HttpHeaders(), responseType: 'text'}).pipe(
            map((response) => {
                return response;
            }),
            catchError((httpError: HttpErrorResponse) => {
                var error = this.handleHttpError(httpError);
                return throwError(error);
            })
        );

    }

    public logout() {

        this.tokenService.removeToken();
        this.router.navigate(['/login']);

    }

    private handleHttpError(httpError: HttpErrorResponse) : string {

        console.error(httpError);
        var error = typeof httpError.error === 'string' ? JSON.parse(httpError.error) : null;
        return error ? error.message : 'Error desconocido';

    }

}
